module.exports = __webpack_public_path__ + "static/kubernetes-7dd97d081916b13e6a71fecdd63796e1.svg";